module.exports = __webpack_public_path__ + "img/mel_tram.c8ee93c6.jpg";